// imports
import DrupalView from 'minsky-kit/js/components/DrupalView';
import { Datepicker } from 'vanillajs-datepicker';
import DropdownDrupalFilter from './DropdownDrupalFilter';
import moment from '../utils/moment';
import SearchWidgetApp from '../../vue/apps/SearchWidgetApp';

// private statics

// class definition
export default class ProgramView extends DrupalView {
    // constructor
    constructor (args = {}, objectName = 'ProgramView') {
        args.debug = args.debug || true;

        // super
        super(args, objectName);

        // add listeners
        this.on('view_refresh', onViewRefresh);

        this.isArchive = args.isArchive || false;

        this.typeFilterChanged = false;
        this.genreFilterChanged = false;

        initView.call(this);
    }

    // methods
    refresh (...args) {
        super.refresh(...args);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils
function initView () {
    this._$submit = this.$el.querySelector('.form-submit');

    this.$typeFilter = this.$el.querySelector('.views-exposed-form .form-item-type');
    this.$genreFilter = this.$el.querySelector('.views-exposed-form .form-item-genre');
    this.$monthFilter = this.$el.querySelector('.views-exposed-form .form-item-month-filter-min').parentNode.parentNode;

    if (this.$typeFilter) {
        this.$typeFilter = new DropdownDrupalFilter({
            $el: this.$typeFilter,
        });

        this.typeFilterChanged = false;

        this.$typeFilter.on('change', this.blm.addOnce('onTypeFilterChange', onTypeFilterChange));
        this.$typeFilter.on('hide', this.blm.addOnce('onTypeFilterHide', onTypeFilterHide));
    }

    if (this.$genreFilter) {
        this.$genreFilter = new DropdownDrupalFilter({
            $el: this.$genreFilter,
        });

        this.genreFilterChanged = false;

        this.$genreFilter.on('change', this.blm.addOnce('onGenreFilterChange', onGenreFilterChange));
        this.$genreFilter.on('hide', this.blm.addOnce('onGenreFilterHide', onGenreFilterHide));
    }

    if (this.$monthFilter) {
        const urlParam = gup('month_filter[min]');

        const monthInputs = {
            min: this.$el.querySelector('.form-item-month-filter-min input'),
            max: this.$el.querySelector('.form-item-month-filter-max input'),
        };

        const $dateField = document.createElement('input');
        $dateField.setAttribute('type', 'text');
        $dateField.setAttribute('placeholder', 'Maand');

        this.$monthFilter.parentNode.insertBefore($dateField, this.$monthFilter);
        this.$monthFilter.classList.add('noRender');

        let datepicker = null;

        if (this.isArchive) {
            datepicker = new Datepicker($dateField, {
                pickLevel:   1,
                startLevel:  1,
                format:      'MM - yyyy',
                autohide:    true,
                clearBtn:    true,
                orientation: 'bottom left',
                maxDate:     Date.now(),
            });
        }
        else {
            datepicker = new Datepicker($dateField, {
                pickLevel:   1,
                startLevel:  1,
                format:      'MM - yyyy',
                autohide:    true,
                clearBtn:    true,
                orientation: 'bottom left',
                minDate:     Date.now(),
            });
        }

        if (urlParam) {
            const value = moment(gup('month_filter[min]'), 'YYYYMMDD').format();
            datepicker.setDate(new Date(value));
        }

        datepicker.element.addEventListener('hide', () => {
            const date = new Date(datepicker.dates[0]);

            const min = `${moment(date).format('YYYYMMDD')}`;
            const max = `${moment(date).add(1, 'month').format('YYYYMMDD')}`;

            if (datepicker.dates[0]) {
                monthInputs.min.value = min;
                monthInputs.max.value = max;
            }
            else {
                monthInputs.min.value = '';
                monthInputs.max.value = '';
            }

            onFilterChange.call(this);
        });
    }

    if(this.$el.querySelector('.js-form-item-title')) {
        const $widget = this.$el.querySelector('.js-form-item-title');
        this.searchWidgetApp = new SearchWidgetApp({
            $el: $widget,
            drupal: Drupal,
            type: this.isArchive ? 'archive' : 'program',
        });
    }

    this._$submit.classList.add('noRender');
    const $resetButton = document.createElement('a');
    $resetButton.setAttribute('href', window.location.pathname);
    $resetButton.innerHTML = 'Reset filters';
    $resetButton.classList.add('js-form-submit');

    this._$submit.parentNode.appendChild($resetButton);
}

// Event handlers
function onViewRefresh () {
    initView.call(this);
}

function onGenreFilterChange () {
    this.genreFilterChanged = true;
}

function onGenreFilterHide () {
    // console.log(this.genreFilterChanged);
    if (this.genreFilterChanged) {
        this._$submit.click();
    }

    this.genreFilterChanged = false;
}

function onTypeFilterChange () {
    this.typeFilterChanged = true;
}

function onTypeFilterHide () {
    if (this.typeFilterChanged) {
        this._$submit.click();
    }

    this.typeFilterChanged = false;
}

function onFilterChange () {
    this._$submit.click();
}

function gup (name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    const regexS = `[\\?&]${name}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results == null ? null : results[1];
}
